import { Injectable } from '@angular/core';
import { Map } from 'immutable';
import { ITrackingProperties } from '../../../tracking/tracking.data';
import { PayloadTypeEnum } from '../../../features-data/features-data.data';

/**
 * Provide functionalities for item save feature
 */

@Injectable()
export class ItemSaveService {
  hasItemSaveV1Enabled(payloads: Map<string, any>): boolean {
    const variant = this._getVariant(payloads);

    if (!variant) {
      return false;
    }

    return variant === 'global_item_save_V1';
  }

  getVariantKeyTracking(payloads: Map<string, any>): ITrackingProperties {
    return {
      variant_key: this._getVariant(payloads),
    };
  }

  private _getVariant(payloads: Map<string, any>): string {
    const saveItemPayload =
      payloads && payloads.get(PayloadTypeEnum.save_items);
    return saveItemPayload && saveItemPayload.get('variant');
  }
}
